import 'normalize.css'
import '@/styles/index.scss'
// import '@/components/vant-ui'
import '@/plugins/native.history'
// import '@/theme/init-theme'
import 'vant/lib/index.css';
import {setVant} from "@/components/vant-ui"
import {setTheme} from "@/theme/init-theme"
import { getUrlParamByName } from '@/utils/common'
import riskRedIcon from '@/assets/images/ai-analysis/risk-red.png'
import fallRedIcon from '@/assets/images/ai-analysis/fall-red.png'
import riskGreenIcon from '@/assets/images/ai-analysis/risk-green.png'
import fallGreenIcon from '@/assets/images/ai-analysis/fall-green.png'

// 判断是否为生产模式
const isProd = import.meta.env.PUBLIC_ENV === 'prod'
// 非生产模式下，使用eruda
if (!isProd) {
  const eruda = require('eruda')
  eruda.init({ tool: ['console', 'elements', 'network', 'resources'] })
}

let redUpGreenDown = getUrlParamByName('redUpGreenDown') //redUpGreenDown 1 红涨绿跌 ，2绿涨红跌，旧版本APP ai-analysis 中参数是type
const pathname=window.location.pathname
if(pathname.includes('/ai-analysis')&&window.location.href.indexOf('type=') !== -1){
 redUpGreenDown=getUrlParamByName('type')
}
if(!redUpGreenDown){
 redUpGreenDown=1  //默认红涨绿跌
}
export function commonMethod(vue){
  vue.config.globalProperties.redUpGreenDown=redUpGreenDown
  vue.config.globalProperties.colorUp=redUpGreenDown==1?"#F9434A":"#00AD3C" //涨的颜色
  vue.config.globalProperties.iconUp=redUpGreenDown == 1 ? riskRedIcon : riskGreenIcon //涨的图标
  vue.config.globalProperties.colorDown=redUpGreenDown==1?"#00AD3C":"#F9434A" //跌的颜色
  vue.config.globalProperties.iconDown=redUpGreenDown == 1 ? fallGreenIcon : fallRedIcon //跌的图标
  setVant(vue)
  setTheme(vue)
}
